import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import config from '@app/configs/config';
import { LulaLogoWhite } from '@/app/icons';

const ENABLED_MENU_ITEMS = {
  customerProfile: true,
  documents: true,
  banking: config.isBankModuleEnabled,
  credit: config.isCreditModuleEnabled,
  notes: false,
};

const items = [
  {
    label: 'Customer profile',
    icon: 'ri-id-card-line',
    activeIcon: 'ri-id-card-fill',
    id: 'customer-profile',
    uri: '/customer/company',
    enabled: ENABLED_MENU_ITEMS.customerProfile,
  },
  {
    label: 'Documents',
    icon: 'ri-file-line',
    activeIcon: 'ri-file-fill',
    id: 'documents',
    uri: '/customer/documents',
    enabled: ENABLED_MENU_ITEMS.documents,
  },
  {
    label: 'Banking',
    icon: 'ri-wallet-3-line',
    activeIcon: 'ri-wallet-3-fill',
    id: 'banking',
    uri: '/customer/banking',
    enabled: ENABLED_MENU_ITEMS.banking,
  },
  {
    label: 'Credit',
    icon: 'ri-coins-line',
    activeIcon: 'ri-coins-fill',
    id: 'credit',
    uri: '/customer/credit',
    enabled: ENABLED_MENU_ITEMS.credit,
  },
  {
    label: 'Notes',
    icon: 'ri-sticky-note-line',
    activeIcon: 'ri-sticky-note-fill',
    id: 'notes',
    uri: '/customer/notes',
    enabled: ENABLED_MENU_ITEMS.notes,
  },
];

interface SidebarItemProps {
  title: string;
  isActive?: boolean;
  icon: string;
  activeIcon: string;
  onClick: () => void;
}

const SidebarItem: FC<SidebarItemProps> = ({
  title,
  isActive,
  icon,
  activeIcon,
  onClick,
}) => {
  return (
    <div
      className={`h-11 px-2.5 py-3 cursor-pointer rounded-md flex items-center gap-2 ${
        isActive
          ? 'bg-white text-navy-700 text-subtitle2b'
          : 'bg-primary hover:text-white text-navy-100 text-subtitle2a'
      }`}
      role="presentation"
      onClick={onClick}
    >
      <i className={isActive ? activeIcon : icon} />
      <div>{title}</div>
    </div>
  );
};

const Sidebar: FC = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const handleItemClick = (uri: string) => {
    navigate(uri);
  };

  return (
    <div className="!w-[264px] px-4 py-8 bg-primary shadow flex flex-col gap-8 flex-shrink-0">
      <LulaLogoWhite />
      <div className="flex flex-col gap-2">
        {items
          .filter((item) => item.enabled)
          .map((item) => (
            <SidebarItem
              key={item.id}
              activeIcon={item.activeIcon}
              icon={item.icon}
              isActive={pathname.includes(item.uri)}
              title={item.label}
              onClick={() => handleItemClick(item.uri)}
            />
          ))}
      </div>
    </div>
  );
};

export default Sidebar;
